module.exports = __webpack_public_path__ + "static/our-home-016633c072e6a92775387393680f830a.png";